import greenLamp from "../../images/lamp/green.png"
import yellowLamp from "../../images/lamp/yellow.png"
import redLamp from "../../images/lamp/red.png"
import turnedOff from "../../images/lamp/turned_off.png"

export const LAMP_MAP = {
  green: {
    image: greenLamp,
    message: "空き",
  },
  yellow: {
    image: yellowLamp,
    message: "やや混み",
  },
  red: {
    image: redLamp,
    message: "混み",
  },
  turnedOff: {
    image: turnedOff,
    message: "情報なし",
  },
}

export const SHELTER_LAMP_MAP = {
  green: {
    image: greenLamp,
    message: "空き",
  },
  yellow: {
    image: yellowLamp,
    message: "やや混み",
  },
  red: {
    image: redLamp,
    message: "満員",
  },
  turnedOff: {
    image: turnedOff,
    message: "情報なし",
  },
}
